export default __webpack_public_path__ + "static/media/tool-icon-cross-red.0c35e0cc.svg";